import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import user from "./modules/user";
import create from "./modules/create";
import search from "./modules/search";
import mobile from "./modules/mobile";
import yunMobile from "./modules/yunMobile";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    create,
    search,
    mobile,
    yunMobile
  },
  state: {
    urgentTel: ""
  },
  mutations: {
    setUrgent(state, payload) {
      state.urgentTel = payload;
    }
  },
  actions: {
    setUrgentAction({ commit }, payload) {
      commit("setUrgent", payload);
    }
  },
  plugins: [
    createPersistedState({
      storage: window.localStorage,
      reducer(val) {
        return {
          user: val.user
        };
      }
    }),
    createPersistedState({
      storage: window.sessionStorage,
      reducer(val) {
        return {
          yunMobile: val.yunMobile,
          mobile: val.mobile
        };
      }
    })
  ]
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js